export const ieo = {
    zzjx: 'Sedang Berlangsung',
    rgjl: 'Catatan Berlangganan',
    yjjs: 'Telah Berakhir',
    sf: 'Peluncuran Perdana',
    mjze: 'Total Pengumpulan',
    ckjz: 'Progress Penggalangan Dana',
    tips_1: 'Platform Biking Startup telah diluncurkan, mari temukan kode kekayaan bersama Biking!',
    tips_2: 'Proyek berkualitas akan segera hadir, nantikan',
    jyjjks: 'Trading Akan Segera Dimulai',
    ksjy: 'Mulai Trading',
    qjy: 'Pergi Trading',
    xmmc: 'Nama Proyek',
    xmfjs: 'Pengenalan Tim Proyek',
    syxm: 'Semua Proyek',
    banner_1: 'Meluncurkan platform peluncuran perdana proyek blockchain baru',
    banner_2: 'Biking mencari bintang hitam blockchain bersama, memulai jalan menuju kebebasan finansial',
    ywc: 'Telah Selesai',
    rgsj: 'Waktu Berlangganan:',
    zcz: 'Pendukung',
    dqjd: 'Progress Saat Ini',
    yck: 'Dana Terkumpul',
    sddb: 'Token Diterima',
    dff: 'Menunggu Distribusi',
    zwxm: 'Belum Ada Proyek',
    xq: 'Detail',
    wksyr: 'Belum Mulai Pemanasan',
    yrz: 'Sedang Pemanasan',
    jxz: 'Sedang Berlangsung',
    yjs: 'Telah Berakhir',
    ts: 'Peringatan',
    dbwfjy: 'Token ini sementara tidak dapat diperdagangkan',
    ckqtdb: 'Silakan lihat token lainnya',
    xm: 'Proyek',
    ksrg: 'Mulai Berlangganan',
    yrg: 'Telah Berlangganan',
    xmjs: 'Pengenalan Proyek',
    csjg: 'Harga Awal',
    dbzl: 'Total Token: {amount} koin',
    cssz: 'Kapitalisasi Pasar Awal: {fdv} USD',
    xmcytj: 'Syarat Partisipasi Proyek',
    cjygzh: 'Buat akun Biking',
    yyzh: 'Sudah punya akun, login langsung',
    dlzhjkcy: 'Login ke akun untuk berpartisipasi dalam berlangganan',
    dljkrg: 'Login ke akun untuk berlangganan',
    xhzc: 'Aset Spot',
    zcdy: 'Aset Spot ≥ 10 USDT',
    rggz: 'Aturan Berlangganan',
    rgcg: 'Berlangganan Berhasil',
    cgrgxm: 'Selamat! Anda telah berhasil berlangganan proyek!',
    fhsy: 'Kembali ke Halaman Utama',
    cyrghd: 'Ikuti Aktivitas Berlangganan Biking Startup',
    rgje: 'Jumlah Berlangganan',
    xhzcgz: 'Perkiraan Nilai Aset Spot',
    rgsm: 'Penjelasan Berlangganan:',
    rgsm1: '1. Jumlah berlangganan perorang ≥{amount1}USDT; ≤{amount2}USDT;',
    rgsm2: "2. Proyek mengalokasikan berlangganan secara proporsional berdasarkan investasi, jika jumlah berlangganan pengguna melebihi jumlah yang dialokasikan, sisa U akan dikembalikan ke akun tunai setelah berlangganan berakhir",
    qd: 'Konfirmasi',
    dyr: 'Menunggu Pemanasan',
    rgdjs: 'Hitungan Mundur Berlangganan',
    yrdjs: "Hitungan Mundur Pemanasan",
    jykqdjs: 'Hitungan Mundur Mulai Trading',
    qrg: 'Pergi Berlangganan',
    rgjebdy: 'Jumlah berlangganan minimum tidak kurang dari {amount} USDT',
    rgjebgy: 'Jumlah berlangganan maksimum tidak lebih dari {amount} USDT',
    rgjeccdqjc: 'Jumlah berlangganan melebihi jumlah aset saat ini',
    fxts1: "1. Proyek startup masih dalam tahap awal, operasi proyek, teknologi dasar, lingkungan hukum dan peraturan, dll., mungkin memiliki risiko besar.",
    fxts2: "2. Memahami Token dan menilai risiko inherentnya membutuhkan penguasaan teknik dan pengetahuan keuangan tingkat lanjut.",
    fxts3: "3. Dipengaruhi oleh teknologi, hukum dan peraturan, pasar, dan faktor lainnya, harga Token yang Anda beli dapat berfluktuasi secara drastis, mungkin turun atau naik signifikan.",
    fxts4: "4. Karena alasan teknologi dasar Token atau platform trading BIKING, Token yang Anda beli mungkin tidak dapat ditarik seluruhnya atau sebagian.",
    sfpt: "Platform Peluncuran Perdana Proyek Blockchain",
    xmhzsq: "Aplikasi Kerjasama Proyek",
    hdlx: "Jenis Aktivitas",
    yryq: "Satu Orang Satu Undian",
    yrdq: "Satu Orang Banyak Undian",
    hdjg: "Harga Aktivitas",
    hdsl: "Jumlah Aktivitas",
    zqs: "Total Undian",
    rgqs: "Jumlah Undian Berlangganan",
    rgsl: "Jumlah Berlangganan",
    mqsl: "Jumlah per Undian",
    mrzgqs: "Jumlah Undian Maksimum per Orang",
    qian: "Undian",
    lian: "Chain",
    hdrgsm: "Penjelasan Berlangganan: Berlangganan setelah memenangkan undian, akan dilakukan pengundian acak dari total pemenang undian. Jika berlangganan gagal, USDT yang digunakan akan dikembalikan bersamaan dengan distribusi airdrop untuk pemenang undian.",
    jqqd: "Nantikan hasil undian",
    dbffkjy: "Token dapat diperdagangkan setelah distribusi",
    dzjgb: "Menunggu Pengumuman Undian",
    dzq: "Menunggu Undian",
    ffzt: "Status Distribusi",
    dbff: "Distribusi Token untuk Pemenang Undian",
    yff: "Telah Didistribusikan",
    wzq: "Tidak Memenangkan Undian",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/ieo/ba.js